import { IconButtonProps } from '@mui/material/IconButton';

export enum RotationType {
  None = 'none',
  Quarter = 'quarter',
  Half = 'half',
}

export interface IRotatingIconButtonProps extends IconButtonProps {
  reverse: boolean;
  rotatingMode?: 'rotate' | 'rotateX' | 'rotateY';
  rotationType?: RotationType;
}
